import styles from "./DateRangePicker.module.css";
import { DatePicker } from "antd";
// import moment from "moment";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;

const dateFormat = "YYYY/MM/DD";

const DateRangePicker = () => {
  //   function disabledDate(current) {
  //     return current > moment();
  //   }
  return (
    <div className={styles.date_range_wrap}>
      <div className={styles.label}>Custom Timeline</div>
      <RangePicker
        defaultValue={[
          dayjs("2024/10/10", dateFormat),
          dayjs("2024/10/16", dateFormat),
        ]}
        format={dateFormat}
        // disabledDate={disabledDate}
      />
    </div>
  );
};

export default DateRangePicker;
